import DataApi from '../api/DataApi';
import { normalizePicklistValuesArray } from '../components/reports/charts/chartPicklistColors';
import { withInferredFilterValueType } from './filterFieldValueUtils';

export function mapFilterFromApi(filter) {
  const picklistValues =
    normalizePicklistValuesArray(filter.picklist_values_data) ||
    normalizePicklistValuesArray(filter.picklist_values);
  return withInferredFilterValueType({
    id: filter.id,
    field_config_id: filter.field_config_id,
    field_name: filter.field_name,
    field_label: filter.field_label,
    data_type: filter.data_type,
    object_name: filter.object_name,
    operator: filter.operator || 'equals',
    value: filter.value ?? '',
    is_editable: filter.is_editable !== false,
    order_no: filter.order_no || 1,
    picklist_values: picklistValues,
  });
}

export function parseReportFiltersFromReport(report) {
  if (!report?.filters?.length) return [];
  return report.filters
    .filter((f) => f.field_name && f.field_config_id)
    .map(mapFilterFromApi);
}

export async function loadFilterFieldCatalog(report) {
  const objectNames = new Set();
  if (report?.object_name) objectNames.add(report.object_name);
  (report?.report_objects || []).forEach((obj) => {
    if (obj.target_object_name) objectNames.add(obj.target_object_name);
    if (obj.source_object_name) objectNames.add(obj.source_object_name);
  });
  const names = [...objectNames].filter(Boolean);
  if (!names.length) return [];

  const objectConfigApi = new DataApi('objectconfig');
  const response = await objectConfigApi.post('/fetchconfigs', {
    objectNames: names,
  });
  if (!response?.data?.success) return [];

  const primaryObjectName = report.object_name;
  const allFields = [];
  (response.data.data || []).forEach((config) => {
    if (!config.fields || !Array.isArray(config.fields)) return;
    config.fields.forEach((field) => {
      if (!field?.id) return;
      allFields.push({
        ...field,
        object_name: config.object_name,
        object_label: config.object_label,
        field_display_name: `${config.object_label}: ${field.field_label}`,
        is_primary_object: config.object_name === primaryObjectName,
      });
    });
  });
  return allFields;
}

export async function fetchReportFilterMeta(reportId) {
  const reportBuilderApi = new DataApi('reportbuilder');
  const response = await reportBuilderApi.get(`/${reportId}`);
  if (!response?.data?.success) {
    throw new Error('Failed to load report filters');
  }
  const report = response.data.data;
  const reportFilters = parseReportFiltersFromReport(report);
  const filterAvailableFields = await loadFilterFieldCatalog(report);
  return {
    reportId,
    filter_logic: report.filter_logic,
    filter_custom_logic: report.filter_custom_logic,
    reportFilters,
    originalFilters: reportFilters.map((f) => ({ ...f })),
    filterAvailableFields,
  };
}
